// extracted by mini-css-extract-plugin
export default {"container":"bLfK5","contents":"HKe06","warning":"g3DbN","warningIcon":"H6DhT"};